import { IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { createRoot } from "react-dom/client";

// функция создания стилей для сворачивающихся записей
export async function CreateCollapsibleRecords(div, me, i, td) {
  const RecordLevel = await me.source.getRecordLevel();
  const RecordState = await me.source.getRecordState();

  const ClassfiresIcon = document.createElement("div");
  if (isCollapsibleRecord(RecordState)) {
    ClassfiresIcon.textContent = RecordState === 160 || RecordState === 161 ? "+" : "-";
    ClassfiresIcon.type = RecordState === 160 || RecordState === 161 ? "+" : "-";
    ClassfiresIcon.style.position = "relative";
    ClassfiresIcon.style.cursor = "pointer";
    ClassfiresIcon.style.marginLeft = 6 + "px";
    ClassfiresIcon.style.marginTop = "1px";
    ClassfiresIcon.style.width = "0px";
    ClassfiresIcon.style.height = "0px";
    ClassfiresIcon.id = "ExpandIcon";
    ClassfiresIcon.setAttribute("recordindex", me.source.activeRecord);
    ClassfiresIcon.onclick = function (e) {
      me.source.onRecordCollapsed(e);
    };
  } else if (RecordLevel !== 0) {
    ClassfiresIcon.textContent = ".";
    ClassfiresIcon.type = ".";
    ClassfiresIcon.style.position = "relative";
    ClassfiresIcon.style.marginLeft = 6 + "px";
    // Пока React не заменил текст иконкой, точка не должна занимать отдельную строку и увеличивать высоту строки
    ClassfiresIcon.style.width = "0px";
    ClassfiresIcon.style.height = "0px";
    ClassfiresIcon.style.color = "red";
    ClassfiresIcon.style.fontWeight = "800";
  }
  div.style.marginLeft = 15 + "px";

  // функция монтирования иконок
  if (ClassfiresIcon.textContent !== "") {
    td.appendChild(ClassfiresIcon);
    addIcons(ClassfiresIcon, me, RecordState);
  }

  return ClassfiresIcon.textContent === "" ? null : ClassfiresIcon;
}

export function isCollapsibleRecord(RecordState) {
  switch (RecordState) {
    case 32:
      return true;
    case 160:
      return true;
    case 33:
      return true;
    case 161:
      return true;
    default:
      return false;
  }
}

function addIcons(container, me, state) {
  // +
  if (state === 160 || state === 161) {
    createRoot(container).render(
      <IconButton
        style={{
          height: "20px",
          width: "20px",
          position: "absolute",
          marginLeft: "-6px",
          marginTop: "-1px",
        }}
      >
        <AddIcon style={{ height: "15px", width: "15px" }} fontSize="small" />
      </IconButton>,
    );
  }
  // -
  else if (state === 32 || state === 33) {
    createRoot(container).render(
      <IconButton
        style={{
          height: "20px",
          width: "20px",
          position: "absolute",
          marginLeft: "-6px",
          marginTop: "-1px",
        }}
      >
        <RemoveIcon style={{ height: "15px", width: "15px" }} fontSize="small" />
      </IconButton>,
    );
  }
  // .
  else {
    createRoot(container).render(
      <IconButton
        disabled
        style={{
          height: "20px",
          width: "20px",
          position: "absolute",
          marginLeft: "-6px",
        }}
      >
        <FiberManualRecordIcon color="error" style={{ height: "5px", width: "5px" }} fontSize="small" />
      </IconButton>,
    );
  }
}
